import { createFileRoute, Navigate, redirect } from '@tanstack/react-router';
import { checkRoutePermission } from '@/components/Auth/checkUserPermissions.ts';
import { getDefaultView } from '@/utils/viewHelpers';
import { DocumentHead } from '@/components/core/DocumentHead';

export const Route = createFileRoute('/$tenantId/_layout/students/travels/')({
  component: StudentTravelRedirect,
  beforeLoad: ({ params }) => {
    const hasPermission = checkRoutePermission({
      permission: 'organization:viewer',
    });
    if (!hasPermission) {
      throw redirect({ to: '/$tenantId', params });
    }
  },
});

function StudentTravelRedirect() {
  const { tenantId } = Route.useParams();
  const view = getDefaultView('students/travels');

  return (
    <>
      <DocumentHead
        titleKey="page.students.travels.title"
        descriptionKey="page.students.travels.description"
        resetOnUnmount={false}
      />
      <Navigate
        to="/$tenantId/students/travels/$view"
        params={{ tenantId, view }}
        replace
      />
    </>
  );
}
